import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

const redirectUri = import.meta.env.VITE_REDIRECT_URI;
const clientId = import.meta.env.VITE_CLIENT_ID;
const authority = import.meta.env.VITE_AUTHORITY;

export const msalConfig: Configuration = {
    auth: {
        clientId: clientId ?? '',
        authority: authority ?? '',
        redirectUri: redirectUri ?? 'https://localhost:3000',
        postLogoutRedirectUri: '/',
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        return;
                    case LogLevel.Verbose:
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const scopes = [`api://${clientId}/user_impersonation`];

export const loginRequest = {
    scopes,
};

export const msalInstance = new PublicClientApplication(msalConfig);
